import { createCustomEnum } from "./customEnum";

const FiservDataGrid = createCustomEnum({
	AuthGridFiserv: {
		value: 0,
		name: "auth_grid_fiserv_id",
		displayName: "Authorisation Pricing Grid",
		error:
			"Authorisation Pricing Grid data is not found. Auto-boarding is not possible. Please update Authorisation Fee, Voice Auth, AVS, Voice AVS, ARU, Transarmor per transaction fee values.",
	},
	MfcGridFiserv: {
		value: 1,
		name: "mfc_grid_fiserv_id",
		displayName: "Merchant Fee Control Grid",
		error:
			"Merchant Fee Control Grid  data is not found, Auto-boarding is not possible. Please review your PCI non compliance fee value and pricing applied to an application.",
	},
	UserDefinedGridFiserv: {
		value: 2,
		name: "user_defined_grid_fiserv_id",
		displayName: "User Defined Pricing Grid",
		error:
			"User Defined Pricing Grid data is not found. Auto-boarding is not possible. Please review your Miscellaneous Fees and Monthly Fees fee values.",
	},
});

export default FiservDataGrid;
